<template>
  <div id="app_signup">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />

    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-8>
        <v-card outlined tile style="min-height:80vh">
          <v-layout wrap pt-10 justify-center>
            <v-flex xs12 md12 text-center>
              <span style="font-size:20px;font-weight:500;">Bank Details</span>
            </v-flex>
            <v-flex px-4 xs12 md3 text-center>
              <span v-if="userType == 'Individual'">Individual Investor</span>
              <span v-if="userType=='Company'">Company Account</span>
              <v-progress-linear :value="100" color="#fb6b0b" height="2"></v-progress-linear>
            </v-flex>
            <v-flex xs12 md12 pt-2 text-center>
              <span style="font-sizer:14px;font-weight:400;color:#a9a9a9">{{userEmail}}</span>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex px-4 xs12 sm12 md3 text-center>
              <v-text-field
                ref="bank"
                :rules="[rules.required]"
                v-model="bank"
                label="Bank"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                ref="accountHolder"
                :rules="[rules.required]"
                v-model="accountHolder"
                label="Account Holder"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                ref="accountNo"
                :rules="[rules.required]"
                v-model="accountNo"
                label="Account Number"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                ref="bankCode"
                :rules="[rules.required]"
                v-model="bankCode"
                label="Bank Code"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                ref="branch"
                :rules="[rules.required]"
                v-model="branch"
                label="Branch"
                color="#26af82"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 md12 pa-10 text-center>
              <br />
              <v-btn
                width="220"
                class="text-capitalize"
                :ripple="false"
                color="#26af82"
                dark
                small
                @click="submit"
              >Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      userEmail: localStorage.getItem("email"),
      userType: localStorage.getItem("userType"),
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      bank: null,
      accountHolder: null,
      accountNo: null,
      bankCode: null,
      branch: null,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters"
      }
    };
  },
  computed: {
    form() {
      return {
        bank: this.bank,
        accountHolder: this.accountHolder,
        accountNo: this.accountNo,
        bankCode: this.bankCode,
        branch: this.branch
      };
    }
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.msg = response.data.msg;
        })
        .catch(err => {
          this.appLoading = false;
          this.msg = err;
        });
    },
    submit() {
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;
        this.$refs[f].validate(true);
      });
      if (!this.formHasErrors) {
        this.addBank();
      } else {
        this.msg = "Please Validate Input";
        this.showsnackbar = true;
      }
    },
    addBank() {
      this.appLoading = true;
      var bankData = {};
      bankData["Bank"] = this.bank;
      bankData["AccountHolder"] = this.accountHolder;
      bankData["AccountNumber"] = this.accountNo;
      bankData["BankCode"] = this.bankCode;
      bankData["Branch"] = this.branch;
      axios({
        method: "POST",
        url: "/bank/add",
        data: bankData,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          this.$router.push("/CompleteProfileSuccess");
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
.confbox >>> label {
  color: black !important;
  font-size: 11px !important;
  line-height: 12px !important;
}
.upload-btn-wrapper {
  position: relative;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>